module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/rimini.dfd1252cbc04d217fd0697b891316852.jpg";